import React, { FC } from 'react';

import { Portal } from 'Modules/ui';

import styles from './index.module.scss';


export const UiPortal: FC = () => (
    <Portal>
        <div id='ui-portal' className={styles.uiPortal} />
    </Portal>
);
